var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2694(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 7,
    viewBox: "0 0 19 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_984",
    "data-name": "Line 984",
    d: "M18,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H18a.5.5,0,0,1,.5.5A.5.5,0,0,1,18,.5Z",
    fill: "rgba(112,112,112,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_985",
    "data-name": "Line 985",
    d: "M18,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H18a.5.5,0,0,1,.5.5A.5.5,0,0,1,18,.5Z",
    transform: "translate(0 6)",
    fill: "rgba(112,112,112,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2694);
export default __webpack_public_path__ + "static/media/Group2694.6a97149ee772cd7342f16518ed2562cb.svg";
export { ForwardRef as ReactComponent };